<template>
<v-dialog v-model="dialog" scrollable max-width="1180px" transition="dialog-transition" :fullscreen="$vuetify.breakpoint.smAndDown" persistent @keydown.esc="emitExit()">
    <v-card flat class="hotel-modal" id="facilities">
        <v-card-title primary-title>
            <div class="pl-2 hotel-modal-header">
                {{ $t('hotel.modal.facilities.title') }}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <div class="px-3">
            <v-row align="center">
                <v-col cols="12" md="6">
                    <v-text-field class="ma-0 py-0 pl-2" v-model="search" clearable :placeholder="$t('hotel.facilities.search_placeholder')" append-icon="search"></v-text-field>
                </v-col>
            </v-row>
        </div>
        <v-card-text class="scroll-card" ref="card-facility" id="scroll-target" v-scroll:#scroll-target="onScroll">
            <v-row>
                <v-col md="10" cols="12" class="py-0">
                    <div>
                        <div>
                            <div class="important pl-2 pt-2" id="activities">{{ $t('hotel.facilities.activities') }}</div>
                            <v-row class="pt-2">
                                <v-col md="3" sm="6" cols="12" v-for="item in filterActivities()" :key="item.id" class="py-0">
                                    <v-checkbox class="im-check-box ma-0 pa-0" v-model="activities_ids" :label="$t('hotel-activities.'+ item.slug)" :value="item.id" color="primary" @change="selectedActivity(item.id)" />
                                </v-col>
                            </v-row>
                            <div class="important pl-2 pt-2">{{ $t('hotel.facilities.facilities') }}</div>
                        </div>
                        <div v-for="(category,index) in unique_categories" :key="index">
                            <div v-if="filterCategories(category).length > 0" column class="pl-2">
                                <div :ref="category" class="subheading pl-2 py-2" style="text-transform: capitalize;" :id="category">{{ $t('hotel.facilities.category.' + category) }}</div>
                                <v-row>
                                    <v-col md="3" sm="6" cols="12" v-for="(item_category,item_index) in filterCategories(category)" :key="item_category.id">
                                        <v-checkbox class="im-check-box ma-0 pa-0" v-model="facilities_ids" :label="$t('hotel-facilities.'+ item_category.slug)" :value="item_category.id" color="primary" @change="selectedFacility(item_category.id)" />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col v-if="!search" md="2" :class="{'py-0': true, 'd-none': $vuetify.breakpoint.smAndDown}">
                    <v-list class="pt-0 menu-fixed" v-if="!search" id="menu_facilities">
                        <v-list-item v-for="(item_menu,index) in menu_items" :key="index" @click="">
                            <v-list-item-content @click="goTo(item_menu)" :id="'menu_'+item_menu">
                                <v-list-item-title>{{ $t('hotel.facilities.category.' + item_menu) }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>

        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>

</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        dialog: Boolean,
        item: Object,
        config: Object
    },
    name: `hotel-facilities`,

    data() {
        return {
            menu_fixed: false,
            loading_save: false,
            target: null,
            dialog_price_faciliy: false,
            activities_ids: [],
            facilities_ids: [],
            selected_activities: [],
            selected_categories: [],
            selected_facilities: [],
            facilities_categories: [],
            search: null,
            select: null,
            options: {
                duration: 300,
                offset: 50,
                easing: 'easeInOutCubic'

            },
        };
    },

    computed: {

        unique_categories: {
            get: function () {
                if(this.config.facilities) {
                    let facilities = this.config.facilities;
                    return [...new Set(facilities.map(item => item.category))];
                } else {
                    return null
                }
            }
        },

        menu_items: {
            get: function () {
                if(this.config.facilities) {
                    let items = ['activities']
                    let facilities = this.config.facilities;
                    let unique_facilities = [...new Set(facilities.map(item => item.category))]
                    return items.concat(unique_facilities);
                } else {
                    return null
                }
            }
        },

    },

    mounted() {
        // prepare models  for activities and facilities selection
        let f_ids = [];
        if(Array.isArray(this.item.static.facilities)) {
            this.item.static.facilities.forEach(function (item) {
                if(item !== null) {
                    this.facilities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            f_ids = Object.keys(this.item.static.facilities);
            f_ids.forEach(function (item) {
                if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                    this.facilities_ids.push(Number(item))
                }
            }.bind(this))
        }

        let a_ids = [];
        if(Array.isArray(this.item.static.activities)) {
            this.item.static.activities.forEach(function (item) {
                if(item !== null) {
                    this.activities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            a_ids = Object.keys(this.item.static.activities);
            a_ids.forEach(function (item) {
                if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                    this.activities_ids.push(Number(item))
                }
            }.bind(this))
        }
    },

    watch: {
        item: {
            handler: function (value) {
                this.facilities_ids = [];
                let f_ids = [];
                if(Array.isArray(this.item.static.facilities)) {
                    this.item.static.facilities.forEach(function (item) {
                        if(item !== null) {
                            this.facilities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    f_ids = Object.keys(this.item.static.facilities);
                    f_ids.forEach(function (item) {
                        if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                            this.facilities_ids.push(Number(item))
                        }
                    }.bind(this))
                }

                let a_ids = [];
                this.activities_ids = [];
                if(Array.isArray(this.item.static.activities)) {
                    this.item.static.activities.forEach(function (item) {
                        if(item !== null) {
                            this.activities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    a_ids = Object.keys(this.item.static.activities);
                    a_ids.forEach(function (item) {
                        if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                            this.activities_ids.push(Number(item))
                        }
                    }.bind(this))
                }
            },
            deep: true
        },

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        onScroll(e) {
            let current = document.getElementsByClassName("customActive");
            if(current.length) {
                current[0].className = current[0].className.replace(" customActive", "");
            }

            for(let i = 0; i < (this.menu_items.length - 1); i++) {
                if((e.target.scrollTop + 166) > document.getElementById(this.menu_items[i])
                    .offsetTop && (e.target.scrollTop + 150) < document.getElementById(this.menu_items[i + 1])
                    .offsetTop) {
                    document.getElementById('menu_' + this.menu_items[i])
                        .classList.add("customActive");
                    return
                }
            }
        },

        filterCategories(filter) {

            let locale_facilities = this.$i18n.messages[this.$i18n.locale]['hotel-facilities'];
            let keys = Object.keys(locale_facilities)
                .filter(function (key) {
                    if(locale_facilities[key].toLowerCase()
                        .includes(this.search || '')) {
                        return key
                    }
                }.bind(this));

            let items = this.config.facilities.filter(e => {
                return keys.includes(e.slug) && e.category === filter
            })

            return items;
        },

        filterActivities() {
            let locale_facilities = this.$i18n.messages[this.$i18n.locale]['hotel-activities'];
            let keys = Object.keys(locale_facilities)
                .filter(function (key) {
                    if(locale_facilities[key].toLowerCase()
                        .includes(this.search || '')) {
                        return key
                    }
                }.bind(this));

            let items = this.config.activities.filter(e => {
                return keys.includes(e.slug)
            })
            return items
        },

        selectedActivity(value) {
            if(this.activities_ids.includes(value)) {
                this.$set(this.item.static.activities, value, {
                    'id': value,
                    'price': null
                })
            } else {
                this.$set(this.item.static.activities, value, null)
            }
        },

        selectedFacility(value) {
            if(this.facilities_ids.includes(value)) {
                this.$set(this.item.static.facilities, value, {
                    'id': value,
                    'price': null
                })

            } else {
                this.$set(this.item.static.facilities, value, null)
            }
        },

        save() {
            this.loading_save = true;
            // prepare some data for saving
            let model = {
                static: {
                    activities: {},
                    facilities: {},
                }
            };
            this.activities_ids.forEach(function (id) {
                model.static.activities[id] = {
                    id: id,
                    price: null
                }
            });
            this.facilities_ids.forEach(function (id) {
                model.static.facilities[id] = {
                    id: id,
                    price: null
                }
            });
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = [];
            hotel.static.activities = model.static.activities;
            hotel.static.facilities = model.static.facilities;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        goTo(value) {
            let container = document.getElementById(value);
            this.$refs['card-facility'].scrollTop = container.offsetTop - 150;
        },

        emitExit() {
            this.$emit('exit')
        }
    },

};
</script>
<style lang="stylus">
#menu_facilities
    &.menu-fixed
        position: sticky
        top: 20px
        .customActive
            padding-left: 5px
            border-left: 2px solid #5A8DEE
            transition: .25s ease-in-out
</style>
